module.exports = __webpack_public_path__ + "static/media/placeholder.1d9605b3.svg";